import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import ProductCatalog from './components/ProductCatalog';
import Cta from './components/Cta';

export default function Products() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="智慧停车产品 | 路内停车设备 · 停车场设备 | 华辉数智"
        description="华辉数智智慧停车产品，涵盖路内停车设备与停车场设备两大类共 15 款终端，包括车辆探测器、网关、PDA 手持终端、RFID 读卡器、高速道闸、车牌识别一体机等。"
        keywords="智慧停车产品,路内停车设备,停车场设备,车辆探测器,车牌识别一体机,华辉数智"
        path="/products"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          name: '智慧停车产品',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'LORA车辆探测器' },
            { '@type': 'ListItem', position: 2, name: 'NB-IOT车辆探测器' },
            { '@type': 'ListItem', position: 3, name: '网关' },
            { '@type': 'ListItem', position: 4, name: 'PDA手持终端' },
            { '@type': 'ListItem', position: 5, name: '车载卡' },
            { '@type': 'ListItem', position: 6, name: 'RFID读卡器' },
            { '@type': 'ListItem', position: 7, name: 'RFID雷达探测读卡器' },
            { '@type': 'ListItem', position: 8, name: 'AI智能停车视频取证巡检终端' },
            { '@type': 'ListItem', position: 9, name: '高速道闸' },
            { '@type': 'ListItem', position: 10, name: '车牌识别一体机' },
            { '@type': 'ListItem', position: 11, name: '显示屏幕' },
            { '@type': 'ListItem', position: 12, name: '补光灯' },
            { '@type': 'ListItem', position: 13, name: '车位锁' },
            { '@type': 'ListItem', position: 14, name: '诱导屏' },
            { '@type': 'ListItem', position: 15, name: '吊顶式车辆探测器' },
          ],
        }}
      />
      <main>
        <Hero />
        <ProductCatalog />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}